import { GlobalImport } from '../utils/GlobalImport';
let allStop = false;
class Loop {
  queue = [];

  animationLoop(start, end, handler) {
    allStop = false;
    for (let i = start; i < end; i++) {
      this.queue.push(handler);
    }

    let cancelId;
    let stop = false;
    const loop = () => {
      // console.log('loop', cancelId);
      const event = this.queue.pop();
      if (event) {
        event();
      } else {
        stop = true;
        // console.log(allStop);
        cancelAnimationFrame(cancelId);
      }
      cancelId = requestAnimationFrame(loop);
      if (stop) {
        cancelAnimationFrame(cancelId);
        return;
      }
      if (allStop) {
        cancelAnimationFrame(cancelId);
        return;
      }
    };
    loop();
  }

  animationCountLoop(count, handler) {
    this.animationLoop(0, count, handler);
  }

  animationForever(handler) {
    allStop = false;
    let id;
    const loop = () => {
      handler();
      id = requestAnimationFrame(loop);
      if (allStop) {
        cancelAnimationFrame(id);
      }
    };
    loop();
  }

  animationUntil(condition, handler) {
    allStop = false;
    let id;
    const loop = () => {
      handler();
      id = requestAnimationFrame(loop);
      // console.log(condition());
      if (condition() === true) {
        cancelAnimationFrame(id);
      }
    };
    loop();
  }
}
const l = new Loop();
const anyWindow = GlobalImport.getAnyWindow();
anyWindow.l = l;
anyWindow.repeatRange = (start, end, handler) => l.animationLoop(start, end, handler);
anyWindow.repeat = (count, handler) => l.animationCountLoop(count, handler);
// anyWindow.forever = (handler) => l.animationForever(handler);
anyWindow.forever = (handler) => {
  animationTickHandlers.push(handler);
};

anyWindow.repeatUntil = (condition, handler) => l.animationUntil(condition, handler);
anyWindow.freeze = () => (allStop = true);

const animationTickHandlers = [];
const handlers = [];
anyWindow.ready = (handler) => {
  handlers.push(handler);
};
anyWindow.go = () => {
  const AFRAME = GlobalImport.getAFRAME();
  AFRAME.registerComponent('ready', {
    init: async () => {
      for (const h of handlers) {
        await h();
      }
    },
    tick: async () => {
      animationTickHandlers.forEach((element) => {
        element();
        console.log('in tick');
      });
    },
  });
};

// window.addEventListener('load', handler);

export const ready = anyWindow.ready;

const ids: number[] = [];
export async function waitAnimationFrame(isFreeze = false): Promise<number> {
  return new Promise<number>((resolve) => {
    const id = requestAnimationFrame(resolve);
    ids.push(id);
    if (isFreeze) {
      ids.forEach((id) => cancelAnimationFrame(id));
    }
    return id;
  });
}
